// extracted by mini-css-extract-plugin
export default {"root":"page_root__ErF8J","content":"page_content__+zp-H","filter--sticky":"page_filter--sticky__CmV-p","backdrop":"page_backdrop__UwHZW","divider":"page_divider__pImeN"};